"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReactRadioGroup = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.string.trim-start.js");
var _commonComponents = require("../../commonComponents");
var _reactRadioGroup = require("react-radio-group");
var _radioCheckboxLabelHolder = _interopRequireWildcard(require("../../components/labels/radioCheckboxLabelHolder"));
var _utils = require("../../components/utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _checkboxGroup = require("../checkbox2/checkboxGroup");
var _excluded = ["disabled", "options", "displayLabel", "split", "displayRow", "required"],
  _excluded2 = ["items", "input", "meta", "labelStyle", "other", "config", "ComponentWrapper", "otherLabel", "otherValue"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var ReactRadioGroup = exports.ReactRadioGroup = (0, _styledComponents["default"])(_reactRadioGroup.RadioGroup).withConfig({
  displayName: "radioGroup__ReactRadioGroup"
})(["td &{margin-top:-10px;@media only screen and (max-width:760px),(min-device-width:768px) and (max-device-width:1024px){margin-top:auto;", "{margin-bottom:20px;}}}"], _commonComponents.RadioCheckbox);
var buildUniqueId = function buildUniqueId(name, label, value) {
  return "t-".concat(name ? name.replace(/\s/g, "") : _lodash["default"].snakeCase(label), "_").concat(_lodash["default"].snakeCase("".concat(value)));
};

//
// RadioGroup
//
var _default = exports["default"] = function _default(_ref) {
  var items = _ref.items,
    input = _ref.input,
    meta = Object.assign({}, _ref.meta),
    labelStyle = _ref.labelStyle,
    other = _ref.other,
    _ref$config = _ref.config,
    _ref$config$disabled = _ref$config.disabled,
    disabled = _ref$config$disabled === void 0 ? false : _ref$config$disabled,
    _ref$config$options = _ref$config.options,
    options = _ref$config$options === void 0 ? [] : _ref$config$options,
    _ref$config$displayLa = _ref$config.displayLabel,
    displayLabel = _ref$config$displayLa === void 0 ? true : _ref$config$displayLa,
    _ref$config$split = _ref$config.split,
    split = _ref$config$split === void 0 ? false : _ref$config$split,
    _ref$config$displayRo = _ref$config.displayRow,
    displayRow = _ref$config$displayRo === void 0 ? undefined : _ref$config$displayRo,
    _ref$config$required = _ref$config.required,
    required = _ref$config$required === void 0 ? false : _ref$config$required,
    config = (0, _objectWithoutProperties2["default"])(_ref$config, _excluded),
    ComponentWrapper = _ref.ComponentWrapper,
    _ref$otherLabel = _ref.otherLabel,
    otherLabel = _ref$otherLabel === void 0 ? 'Other' : _ref$otherLabel,
    _ref$otherValue = _ref.otherValue,
    otherValue = _ref$otherValue === void 0 ? 'other' : _ref$otherValue,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    otherSelected = _useState2[0],
    setOtherSelected = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    otherInputValue = _useState4[0],
    setOtherInputValue = _useState4[1];
  var otherInputRef = (0, _react.useRef)(null);
  var clearOtherInput = function clearOtherInput() {
    setOtherSelected(false);
    setOtherInputValue('');
  };
  var OnlyOneOption = options.length === 1;
  return /*#__PURE__*/_react["default"].createElement(ReactRadioGroup, {
    className: "radiogroup ".concat((0, _utils.constructFieldClassname)(meta)),
    name: _lodash["default"].snakeCase(input.name),
    selectedValue: otherSelected ? otherValue : _lodash["default"].get(input, 'value.answer') || input.value,
    onChange: function onChange(v) {
      return input.onChange(other && v === otherValue ? undefined : {
        answer: v
      });
    } // filter 'other' to force text input
  }, displayLabel && !OnlyOneOption && /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder.QuestionLabelHolder, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    required: required,
    label: "".concat(rest.label),
    labelStyle: labelStyle
  })), /*#__PURE__*/_react["default"].createElement(_commonComponents.GroupListHolder, {
    displayRow: displayRow
  }, _lodash["default"].map(options, function (item, i) {
    var _alwaysGetKeyValue = (0, _utils.alwaysGetKeyValue)(item),
      label = _alwaysGetKeyValue.label,
      value = _alwaysGetKeyValue.value;
    var unique_id = buildUniqueId(config.name, label, value);
    return /*#__PURE__*/_react["default"].createElement(_commonComponents.RadioCheckbox, {
      split: split,
      options: options,
      key: unique_id
    }, /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], {
      labelFor: unique_id,
      labelStyle: labelStyle,
      label: label,
      displayAfter: true,
      displayLabel: displayLabel || OnlyOneOption,
      displayRow: displayRow
    }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
      id: unique_id,
      value: value,
      disabled: disabled,
      onClick: clearOtherInput
    })));
  }), other && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_commonComponents.RadioCheckbox, {
    split: split,
    options: options,
    key: buildUniqueId(config.name, otherLabel, otherValue)
  }, /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], {
    labelFor: buildUniqueId(config.name, otherLabel, otherValue),
    labelStyle: labelStyle,
    label: otherLabel,
    displayAfter: true,
    displayLabel: displayLabel || OnlyOneOption,
    displayRow: displayRow
  }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
    id: buildUniqueId(config.name, otherLabel, otherValue),
    value: otherValue,
    disabled: disabled,
    onClick: function onClick(e) {
      setOtherSelected(true);
      otherInputRef.current.focus();
    }
  }))), /*#__PURE__*/_react["default"].createElement(_checkboxGroup.OtherInput, {
    "data-test": "other",
    onChange: function onChange(e) {
      var value = e.target.value.trimLeft();
      setOtherInputValue(value);
      if (_lodash["default"].isEmpty(value)) input.onChange(value);else input.onChange({
        answer: 'other',
        user_value: value
      });
    },
    onBlur: function onBlur(e) {
      return input.onBlur();
    },
    disabled: disabled,
    value: otherInputValue,
    required: otherSelected,
    onClick: function onClick(e) {
      setOtherSelected(true);
      input.onChange(otherInputValue);
    },
    ref: otherInputRef
  }))));
};